
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/postman",
      function () {
        return require("private-next-pages/docs/api/postman.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/postman"])
      });
    }
  